const BASE_URL = "https://wateen-portfolio-backend.herokuapp.com/api";

const ENDPOINTS = {
  ADD_CONTACT: "/contact-us",
};

export { BASE_URL, ENDPOINTS };
